import React from 'react'

const ButtonSpinner = () => (
  <span
    className="spinner-border spinner-border-sm"
    style={{ width: '1.15rem', height: '1.15rem', borderWidth: '0.15rem', color: 'white' }}
    role="status"
  />
)

export default ButtonSpinner
